export default "dist/images/block-number-box-heading.f6e96cb.png";